import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    container: {
        marginTop: '0.5rem !important',
    },
    stars: {
        display: 'flex',
        flexDirection: 'row',
    },
    starNoMargin: { width: 18, height: 18 },
    star: { width: 18, height: 18, marginLeft: 2 },
    basedOnReviews: {
        fontSize: 'small',
        color: 'grey',
        marginTop: '0.25rem',
    },
});
